import { Capacitor } from '@capacitor/core';

// Android can kill the whole app process while the app is backgrounded, which
// wipes sessionStorage but not localStorage -- native builds use localStorage
// so a user isn't silently logged out mid-round. Browser/PWA keeps
// sessionStorage, unchanged from today.
const storage = Capacitor.isNativePlatform() ? window.localStorage : window.sessionStorage;

export default storage;
